<script>
import { scanStore } from '../../stores';
import { config } from '../../../scripts/defaultURL';
import { clearForm, formatDate, formatPayloadDate } from '../../../scripts/functions';
import { updateData } from '../../../scripts/rest';
import * as LR from '@uploadcare/blocks';

LR.registerBlocks(LR);

export let scan;

let scanId;
let scanType;
let scanDate;
let scanFollowup;
let scanReminder;
let scanReport;
let scanURL;
let savedScans;

scanId = scan ? scan.id : null;
scanType = scan ? scan.type : null;
scanDate = scan ? formatDate(scan.date) : null;
scanFollowup = scan ? formatDate(scan.followup) : null;
scanReminder = scan ? scan.reminder_sent : null;
scanReport = scan ? scan.report : null;
scanURL = scan ? scan.report_url : null;

$: if (scan) console.table(scan);

$: window.addEventListener('LR_DATA_OUTPUT', (e) => {
    console.log('Upload event:', e.detail);
    scanURL = e.detail.data[0].cdnUrl;
    scanReport = e.detail.data[0].name;
});

function closeModal() {
    clearForm('#editScanModal input, #editScanModal select');
    document.getElementById('editScanModal').classList.remove('is-active')
    $scanStore['todo'] = 'getData'
    scan = null;
}

function save() {
    const scanPayload = {
        date: formatPayloadDate(document.querySelector('#scandate').value),
        type: document.querySelector('#scantype').options[document.querySelector('#scantype').options.selectedIndex].text,
        followup: (document.querySelector('#followup').value != '') ? document.querySelector('#followup').value : null,
        report: document.querySelector('#report a') ? document.querySelector('#report a').text || scanReport : null,
        report_url: document.querySelector('#report a') ? document.querySelector('#report a').href || scanURL : null,
        reminder_sent: scanReminder || null
    };
    
    console.log(`saving scan ${scanId} payload`);
    console.table(scanPayload);

    if (scanPayload.followup == 'Invalid date') {
        console.log(scanPayload.followup, scanFollowup);
        return;
    }

    updateData(`${config.defaultURL}/scans/update/${scanId}`, scanPayload)
    .catch((error) => console.error('Failed to update scan:', error))
    .then((res) => {
        console.table(res)
        savedScans = true;
        closeModal();
    });
}
</script>
  
<style>
.modal-card-title {
    margin-bottom: 0 !important;
}

#report {
    font-weight: 500;
    color: #00947e;
}

#reminder_sent {
    font-size: small;
    color: #00d1b2;
    margin-left: 0.5rem;
}

lr-file-uploader-regular {
   --cfg-pubkey: '7e4a5b839b81f4b3a099';
   --cfg-source-list: 'local';
   --darkmode: 0;
}
</style>
    
<div class="modal" id="editScanModal">
    <div class="modal-background" />
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Edit Scan</p>
            <button on:click={closeModal} class="delete" aria-label="close" />
        </header>
        <section class="modal-card-body">
            <form on:submit|preventDefault={save} >
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Type</label>
                    <div class="select">
                        <select name="type" value={scanType} id="scantype">
                            <option value="">- Select Scan Type -</option>
                            <option value="Breast Study">Breast Study</option>
                            <option value="Chest & Breast Study">Chest & Breast Study</option>
                            <option value="Woman's Health Study">Woman's Health Study</option>
                            <option value="Man's Health Study">Man's Health Study</option>
                            <option value="Full Body Study">Full Body Study</option>
                            <option value="Custom Study">Custom Study</option>
                        </select>
                    </div>
                </div>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Date</label>
                    <input value={scanDate} class="input" type="date" name="scandate" id="scandate" />
                </div>
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Follow up date:</label>
                    <input value={scanFollowup} class="input" type="date" name="followup" id="followup" />
                    {#if (scanReminder)}
                    <div id="reminder_sent">Reminder Sent!</div>
                    {/if}
                </div>
                <!-- {#if (scan.report)} -->
                <div class="field">
                    <!-- svelte-ignore a11y-label-has-associated-control -->
                    <label class="label">Report</label>
                    {#if scanReport}
                    <div id="report"><a href="{scanURL}" target="_blank">{scanReport}</a></div>
                    {:else}
                    <lr-file-uploader-regular css-src="https://unpkg.com/@uploadcare/blocks@0.20.1/web/file-uploader-regular.min.css"></lr-file-uploader-regular>
                    {/if}                    
                </div>
                <!-- {/if} -->
                <div class="field is-grouped">
                    <div class="control">
                        <button class="button is-primary" type="submit">Save</button>
                    </div>
                    <div class="control">
                        <button class="button is-danger" type="button">Delete</button>
                    </div>
                    <div class="control">
                        <button
                        on:click={closeModal}
                        class="button is-primary is-light">Cancel</button>
                    </div>
                </div>   
            </form>
        </section>
    </div>
</div>
    